import { render, staticRenderFns } from "./HireIcon.vue?vue&type=template&id=08a4e5da&"
import script from "./HireIcon.vue?vue&type=script&lang=ts&"
export * from "./HireIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports